// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as ResizeExtended } from '../../../../../ui-v3/src/assets/icons/extended/custom2.0/resize.svg?react';
import { createIcons } from '../../Icon';
const ResizeIcon = /* @__PURE__ */ createIcons('Resize', {
    extended: ResizeExtended
});
ResizeIcon.supportedTypes = [
    'extended'
];
ResizeIcon.category = 'custom2.0';
export default ResizeIcon;
